export default __webpack_public_path__ + "static/media/PJ_Logo.c2e61007.png";